export interface Tier {
	id: string;
	name: string;
	compensation: {
		full: number;
		half: number;
	};
	increase: number;
	elegible: {
		full: number;
		half: number;
	};
	acceptsHalfHour: boolean;
}

export const allTiers: Tier[] = [
	{
		id: 'plan_tier:standard',
		name: '40,00',
		compensation: {
			full: 40,
			half: 20,
		},
		increase: 80,
		elegible: {
			full: 0,
			half: 0,
		},
		acceptsHalfHour: false,
	},
	{
		id: 'plan_tier:silver',
		name: '50,00',
		compensation: {
			full: 50,
			half: 25,
		},
		increase: 60,
		elegible: {
			full: 0,
			half: 0,
		},
		acceptsHalfHour: true,
	},
	{
		id: 'plan_tier:gold',
		name: '60,00',
		compensation: {
			full: 60,
			half: 30,
		},
		increase: 40,
		elegible: {
			full: 0,
			half: 0,
		},
		acceptsHalfHour: false,
	},
	{
		id: 'plan_tier:diamond',
		name: '70,00',
		compensation: {
			full: 70,
			half: 35,
		},
		increase: 20,
		elegible: {
			full: 0,
			half: 0,
		},
		acceptsHalfHour: false,
	},
];
